/* tslint:disable */
/* eslint-disable */
/**
 * External EMR API
 * Clinical documents pulled from external EMRs (Net Health today) for a patient\'s external EHR record. Consumer-agnostic: concurrent review is the first consumer, but nothing here is re-auth specific. Routes are lead-scoped because the pull needs the lead\'s facility to resolve the Net Health credentials and consumer site; the documents themselves belong to the external EHR patient.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExternalEmrDocumentList } from './ExternalEmrDocumentList';
import {
    ExternalEmrDocumentListFromJSON,
    ExternalEmrDocumentListFromJSONTyped,
    ExternalEmrDocumentListToJSON,
} from './ExternalEmrDocumentList';

/**
 * 
 * @export
 * @interface GetExternalEmrDocuments200Response
 */
export interface GetExternalEmrDocuments200Response {
    /**
     * 
     * @type {ExternalEmrDocumentList}
     * @memberof GetExternalEmrDocuments200Response
     */
    data?: ExternalEmrDocumentList;
}

/**
 * Check if a given object implements the GetExternalEmrDocuments200Response interface.
 */
export function instanceOfGetExternalEmrDocuments200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetExternalEmrDocuments200ResponseFromJSON(json: any): GetExternalEmrDocuments200Response {
    return GetExternalEmrDocuments200ResponseFromJSONTyped(json, false);
}

export function GetExternalEmrDocuments200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExternalEmrDocuments200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ExternalEmrDocumentListFromJSON(json['data']),
    };
}

export function GetExternalEmrDocuments200ResponseToJSON(value?: GetExternalEmrDocuments200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ExternalEmrDocumentListToJSON(value.data),
    };
}

